class HalperDOM {
    constructor() {
    }



    addClass(el, className) {
        if (!el.classList.contains(className)) {
            el.classList.add(className)
        }
    }

    removeClass(el, className) {
        if (el.classList.contains(className)) {
            el.classList.remove(className);
        }
    }
    toggleClass(el, className, val) {
        if(!el) return;
        if(!el.length) {
            if (val === undefined) {
                if (el.classList.contains(className)) {
                    el.classList.remove(className);
                } else {
                    el.classList.add(className);
                }
            } else {
                if (val) {
                    this.addClass(el, className)
                } else {
                    this.removeClass(el, className)
                }
            }
        } else {
            for(let i = 0; i < el.length; i++) {
                this.toggleClass(el[i], className, val);
            }
        }
    }
    setStyle(el, name, val) {
        if(el.style[name] !== val) {
            el.style[name] = val;
        }
    }
}
const halperDOM = new HalperDOM();
export default halperDOM;